import React from 'react';

import './home.scss';
import { Link } from '../hooks/router';

export default function Home({ route }) {
  return (
    <div className="home-page">
      <Link to="faq">FAQ</Link>
    </div>
  );
};
